import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import Bugsnag from '@bugsnag/js';
import { REMOVE_PROPERTY } from '@general/graphql/properties.graph';

const usePropertyDelete = ({ onCompleted = () => {} }) => {
    const [removePropertyMutation] = useMutation(REMOVE_PROPERTY, {
        onCompleted,
        onError: e => {
            Bugsnag.notify(e, function(event) {
                event.context = 'Removing property';
            });
        },
    });

    const removeProperty = useCallback(
        async id =>
            removePropertyMutation({
                variables: { id },
                // update: cache => {
                //     const existingItems = cache.readQuery({ query });
                //     const nonNullItems = existingItems.properties.filter(item => !!item);
                //     const newItems = nonNullItems.filter(property => id !== property.id);

                //     cache.writeQuery({
                //         query,
                //         data: {
                //             properties: newItems,
                //         },
                //     });
                // },
            }),
        [removePropertyMutation]
    );

    return removeProperty;
};

export default usePropertyDelete;
